import type { PropsWithChildren } from 'react';
import { createContext, useCallback, useContext } from 'react';

// @TODO replace with useLingui

const FiltersI18nContext = createContext<{
  t: (phrase: keyof FiltersMessages) => string;
} | null>(null);

export type FiltersMessages = {
  Apply: string;
  Clear: string;
  'Show More': string;
  'Show Less': string;
};

type FiltersThemeProviderProps = PropsWithChildren<{
  messages?: FiltersMessages;
}>;

export function FiltersI18nProvider({
  children,
  messages = {
    Apply: 'Apply',
    Clear: 'Clear',
    'Show More': 'Show More',
    'Show Less': 'Show Less'
  }
}: FiltersThemeProviderProps) {
  const t = useCallback(
    (phrase: keyof FiltersMessages) => messages[phrase] ?? phrase,
    [messages]
  );

  return (
    <FiltersI18nContext.Provider value={{ t }}>
      {children}
    </FiltersI18nContext.Provider>
  );
}

export function useFiltersI18n() {
  const context = useContext(FiltersI18nContext);
  if (context === null) {
    throw new Error('useFiltersI18n must be used within a FiltersI18nProvider');
  }
  return context;
}
